import AddIcon from '@mui/icons-material/Add';
import { Button, Card, CardHeader, TableContainer } from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PositionModal from './PositionModal';
import PositionsList from './PositionsList';
import { ConfirmDialog } from '../../../../../../../components/ConfirmDialog';
import { useParameterizedQuery, useMutation } from 'react-fetching-library';
import {
  getOrderAttachmentAction,
  removeOrderAttachmentAction
} from '../../../../../../../services/request';
import PDFPreviewModal from '../PDFPreviewModal';
import toast from 'react-hot-toast';

const AttachedDocumentsTable = ({ formik }) => {
  // const [positions, setPositions] = useState(formik.values.attachments);
  const { order } = useSelector(state => state.orderData);
  const [openModal, setOpenModal] = useState(false);
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const [position, setPosition] = useState(null); // Przechowywanie ID elementu do usunięcia
  const [previewUrl, setPreviewUrl] = React.useState(null);

  const { query } = useParameterizedQuery(getOrderAttachmentAction);
  const { error, mutate } = useMutation(removeOrderAttachmentAction);

  const handleClick = async (
    attachment_id,
    fileName = 'test',
    preview = true
  ) => {
    console.log('preview', attachment_id);
    const { payload, error, loading } = await query(order.id, attachment_id);

    if (!error && !loading) {
      if (preview) {
        setPreviewUrl(window.URL.createObjectURL(payload));
      } else {
        const url = window.URL.createObjectURL(payload);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = `${fileName}.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    }
  };

  console.log('formik', formik.values.attachments);

  const handleOpen = () => {
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  // const handlePreview = id => {
  //   console.log('preview', id);
  // };

  const handleDeleteRequest = item => {
    setPosition(item);
    setOpenConfirmDelete(true);
  };

  const handleDeleteConfirm = async () => {
    if (position !== null) {
      const { error } = await mutate(order.id, position.id);

      if (!error) {
        toast.success('Dokument został usunięty');
        formik.setFieldValue(
          'attachments',
          formik.values.attachments.filter(p => p.id !== position.id)
        );
      } else {
        toast.error('Nie udało się usunąć dokumentu');
        setPosition(null);
        setOpenConfirmDelete(false);
      }
    }
  };

  return (
    <>
      <TableContainer component={Card} sx={{ flex: '1 1 50%', p: 1 }}>
        <CardHeader
          title={
            <>
              Załączone dokumenty
              <Button
                onClick={handleOpen}
                variant="contained"
                startIcon={<AddIcon />}
                sx={{ ml: 2 }}
              >
                Dodaj pozycję
              </Button>
            </>
          }
          sx={{ mb: 2, mt: -1 }}
        />
        <PositionsList
          formik={formik}
          handlePreview={handleClick}
          handleDelete={handleDeleteRequest} // Zmienione na otwarcie modala potwierdzenia
        />
        <PositionModal formik={formik} openModal={openModal} onClose={handleClose} />
      </TableContainer>

      {/* Modal potwierdzenia usunięcia */}
      <ConfirmDialog
        title={`Usuń załącznik ${position ? position.name : null}? `}
        open={openConfirmDelete}
        setOpen={setOpenConfirmDelete}
        onConfirm={handleDeleteConfirm} // Usunięcie dopiero po potwierdzeniu
      >
        Czy na pewno chcesz usunąć załącznik? Ta operacja będzie nieodracalna.
      </ConfirmDialog>
      {previewUrl !== null ? (
        <PDFPreviewModal
          url={previewUrl}
          handleClose={() => setPreviewUrl(null)}
        />
      ) : null}
    </>
  );
};

export default AttachedDocumentsTable;
